import Swal from "sweetalert2";

export const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-success btn-square',
        cancelButton: 'btn btn-danger btn-square ml-2'
    },
    buttonsStyling: false
})